import { process } from '@progress/kendo-data-query';
import {
  Dispatch,
  MouseEvent as ReactMouseEvent,
  SetStateAction,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

import { Button, DropDownButton } from '@progress/kendo-react-buttons';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Grid, GridCellProps, GridColumn, GridColumnMenuProps, GridPageChangeEvent, GridToolbar } from '@progress/kendo-react-grid';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { GridPDFExport } from '@progress/kendo-react-pdf';
import { format } from 'date-fns';
import React from 'react';
import { CSVLink } from 'react-csv';
import SessionStorageService from '../../services/SessionStorageService';
import { GetUserNameTecnico, _export, _exportPdf, b64toBlob, entidadeUser, exportPDFWithMethod, formatCurrency, get, handleDownload, handleGenericError, hasPermission, post, preventPropsNullValues, setCoordenadasPoligono, setExcelExport, setIntervencaoSelected, setModeloSelected, setPdfExport } from '../../services/utils';
import styles from '../../styles/intervencao/Intervencao.module.scss'
import commonStyles from '../../styles/common/Common.module.scss'
import { AUTH_LOCALSTORAGE, CONSULTAR_INTERVENCAO, CURRENT_TIMEZONE, GET_DOCUMENTO, GET_DOCUMENTO_BY_INTERVENCAO, GET_INT_ACAO_SHAPEFILE, GET_INT_INTERVENCOES_SHAPEFILE, GET_LIST_RESULTS_INT_INTERVENCAO, INT_INTERVENCAO_POINT_NAME, LAYER_INDEX_INT_INTERVENCOES, OPERATIONAL_LAYER, PERMISSION_INTERVENCAO_PERFIL_BASICO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_TOTAL, PESQUISAR_DOCUMENTOS_INTERVENCAO, PESQUISAR_ENTIDADEBYUSER, PESQUISAR_INTERVENCAO, RECORDS_LIMIT, RELATORIO_MERGE_INTERVENCAO, URL_AJUDA_INTERVENCOES_INTERVENCAO, clearLayers } from '../../utils/constants';
import { ResultadoIntervencaoCommandGridCell } from './ResultadoIntervencaoCommandGridCell';
import { useIntervencaoStore } from '../../stores/intervencao';
import clsx from 'clsx';
import { useCommonStore } from '../../stores/common';
import MaximizeButton from '../common/MaximizeButton';
import { Dialog } from '@progress/kendo-react-dialogs';
import ImagePreviewV2 from '../viewer/ImagePreviewV2'
import { ResultadoDocumentoCommandGridCell } from '../documentos/ResultadoDocumentoCommandGridCell';
import { faBackward, faTable } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Field } from '@progress/kendo-react-form';
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import VisualizadorColunas from '../Generico/VisualizadorColunas ';
import useVisibleColumns, { Key } from '../../hooks/useVIsibleColumns';
import ReactGA from 'react-ga4';
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais';
import useClearMap from '../../hooks/useClearMap';
import { Session } from 'inspector';
import moment from 'moment'
import "moment-timezone"
import { base64ApaImage, base64FooterImages, base64SiarlImage } from '../../routes/Base64Images';

// import useVisibleColumns from '../../hooks/useVisibleColumns';
type Props = {
  onCloseClick?: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
  setShowResultadoIntervencao: Dispatch<SetStateAction<boolean>>
  setShowRegistarIntervencao: Dispatch<SetStateAction<boolean>>,
  columns: any,
  setColumns: any,
  columnsDocuments: any,
  setColumnsDocuments: any
}

type PageState = {
  skip: number
  take: number
}
const initialDataState: PageState = { skip: 0, take: 20 }
const keyPainelPrincipal:Key = 'intervencoesColunasVisiveis';
const keyPainelDocumentos:Key = 'intervencoesDocumentosColunasVisiveis';

export default function ResultadoIntervencaoForm({
  onCloseClick,
  setShowResultadoIntervencao,
  setShowRegistarIntervencao,
  columns,
  setColumns,
  columnsDocuments,
  setColumnsDocuments,
}: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const [intervencoes, setintervencoes] = useState<any[]>([])
  const [documentosIntervencoes, setDocumentosIntervencoes] = useState([])

  const [selected, setSelected] = useState<number>(0)
  const [page, setPage] = useState<PageState>(initialDataState)
  const selectIntervencaoResult = useIntervencaoStore(
    (state) => state.selectIntervencaoResult
  )
  const selectIntervencaoResultId = useIntervencaoStore(
    (state) => state.selectIntervencaoResultId
  )
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >()

  const isCurrentViewMaximized = useCommonStore(state => state.isCurrentViewMaximized)
  const [clearMap] = useClearMap();

  const getIntervencao = async (data: any) =>
    await get<any, any>(`${PESQUISAR_INTERVENCAO}/` + data)

const consultarIntervencao = async (data: any) => await post<any, any>(`${CONSULTAR_INTERVENCAO}`, data)
const getShapeFile = async (data: any) =>
await post<any, any>(`${GET_INT_INTERVENCOES_SHAPEFILE}`, data)

      const getDocumentosByIntervencaoIDs = async (data: any) =>
  await post<any, any>(`${GET_DOCUMENTO_BY_INTERVENCAO}` , data)

  const getDocumento = async (data: any) =>
  await get<any, any>(`${GET_DOCUMENTO}/` + data)

  const getIntervencaoPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_INT_INTERVENCAO}`, data)

  const relatorioIntervencaoMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE_INTERVENCAO}`, data)



  const [urlDoDocumento, setUrlDoDocumento] = useState("");
  const [idDoDocumento, setIdDoDocumento] = useState("");
  const [openForm, setOpenForm] = useState<boolean>(false)
  const {getVisibleColumns, removeColumnsKeys} = useVisibleColumns();

     const handleMessageEvent = useCallback((event: MessageEvent) => {
        if (event.data.type == "resultadoIntervencaoPesquisaChange") {
            SessionStorageService.setItem("resultadoIntervencaoPesquisa", event.data.value);
        }
    }, [])

     useEffect(() => {
        window.addEventListener(
            'message',
            handleMessageEvent,
            false
        )

        return () => {
            window.removeEventListener(
                'message',
                handleMessageEvent,
                false
            )
        }
    }, [handleMessageEvent])

    const documentosToPreview = documentosIntervencoes

    useEffect(() => {
      ReactGA.send({ hitType: "pageview", page: "/ResultadoIntervencao" });
    }, []);


    const initialized = useRef(false)
    useEffect(() => {
        if (!initialized.current) {
          initialized.current = true;      
        if (SessionStorageService.getItem("lastSearchIntervencao") && !SessionStorageService.getItem("firstCallIntervencao")) {
        postMessage({ type: "showLoader" }, "*");
        const objToSearch = SessionStorageService.getItem("lastSearchIntervencao") ?? '';
        consultarIntervencao(objToSearch).then((data) => {
          SessionStorageService.setItem("resultadoIntervencaoPesquisa", data);
          setResultsIntervencao();
          postMessage({ type: "hideLoader" }, "*");
        })
      } 
      else {
        setResultsIntervencao();
    }
  }
    }, [])

    const setResultsIntervencao = () => {
      try {
  
        const results = typeof SessionStorageService.getItem('resultadoIntervencaoPesquisa') === "string" ? JSON.parse(SessionStorageService.getItem('resultadoIntervencaoPesquisa')) : SessionStorageService.getItem('resultadoIntervencaoPesquisa')
  
        const formattedResults = results.map((item: any) => ({
          ...item,
          inv_global: formatCurrency(item.inv_global),
          fin_nacional: formatCurrency(item.fin_nacional),
          fin_comunitario: formatCurrency(item.fin_comunitario),
          val_executado: formatCurrency(item.val_executado),
        }));
        setintervencoes(formattedResults);        
        try {
          const idsIntervencao = results.map((o: any) => o.id);
          const iframe: any = document.getElementById('iframeGeoPortal')
          
          getDocumentosByIntervencaoIDs(idsIntervencao).then(response => {
            setDocumentosIntervencoes(response.map((item: any) => ({
              ...item,
              data_publicacao: item.data_publicacao ? moment.utc(new Date(item.data_publicacao)).tz(CURRENT_TIMEZONE).format("DD/MM/yyyy") : undefined,
            })))
            console.log(response)
          })
          //getVisibleColumns(keyPainelPrincipal, setColumns)

          const ids: any[] = []
          results.forEach((element: any) => {
            ids.push(element.id)
            })

            iframe.contentWindow?.postMessage(
              { type: 'SiarlDefineExtraLayerTooltipColumns', value:
                { layer: INT_INTERVENCAO_POINT_NAME,  columns: columns.columns.filter((x: { show: any; }) => x.show).map((option: { field: any; title: any; }) => ({
             field: option.field,
             title: option.title
           })) } },
              '*'
            )

            iframe.contentWindow?.postMessage(
              { type: 'SiarlIntIntervencaoSearch', value: {ids : ids, result: results} },
              '*'
            )
            
        } catch (error) {
          console.error('Erro ao buscar os dados:', error)
        }
  
      } catch (e) {
        setintervencoes([]);
      }
    }
      
    useEffect(() => {
      const iframe: any = document.getElementById('iframeGeoPortal')
      const ids: number[] = []
      intervencoes.forEach((element: any) => {
        ids.push(element.id)
      })
      iframe.contentWindow?.postMessage(
        { type: 'SiarlIntIntervencaoSearch', value: ids },
        '*'
      )
    }, [])

  const clearSearchResults = () => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage({ type: "SiarlIntIntervencaoClearLayers", value: "true" }, '*')
    SessionStorageService.removeItem('resultadoIntervencaoPesquisa')
    SessionStorageService.removeItem("lastSearchIntervencao");

    SessionStorageService.removeItem("total_valor_execucao");
    SessionStorageService.removeItem("fin_comunitario");
    SessionStorageService.removeItem("fin_nacional");
    SessionStorageService.removeItem("inv_global");

    setCoordenadasPoligono(undefined);
    clearMap(clearLayers["CLEAR_LAYERS_INTERVENCAO"])

    //postMessage({ type: "form", value: "pesquisarIntervencao" }, "*");
    postMessage({type: "clearSearchResultsIntervencao"}, "*");
    setintervencoes([]);
  }

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected)
    postMessage({type: "subSelectedIntervencaoChange", value: e.selected}, "*");
  }
  const handlePageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent
    const take = event.page.take

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value)
    }

    setPage({
      ...event.page,
      take,
    })
  }

  const handleDocumentPreviewClickById = (documentosLocal: Record<string, any>) => async () => {

    try {

      postMessage({ type: "showLoader" }, "*");
      const documentos = await getDocumento(documentosLocal.id);

      setIdDoDocumento(documentosLocal.id);
      setUrlDoDocumento(documentos.url);
      setOpenForm(true);

    } catch (error) {

      handleGenericError(error, "Não foi possivel abrir o documento!")
      setOpenForm(false);

    } finally {

      postMessage({ type: "hideLoader" }, "*");

    }
  }

  const nextPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const nextIds = documentosToPreview
        .filter((doc: any) => doc.id < idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (nextIds.length > 0) {
        const nextId = Math.max(...nextIds);
        console.log(`O próximo ID é ${nextId}`);
  
        const documento = await getDocumento(nextId);
  
        setIdDoDocumento(nextId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        const intervencao_id = e.intervencao_id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlIntIntervencaoHighlight',
            value: [intervencao_id],
          },
          '*'
        )
  
      } else {
        console.log("Não há um próximo ID na lista.");
      }

    }catch(error){

      postMessage({ type: "errorMsg", value: "Não foi possivel abrir o documento!" }, "*");

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
   
  }

  const previousPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const previousIds = documentosToPreview
        .filter((doc: any) => doc.id > idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (previousIds.length > 0) {
        const previousId = Math.min(...previousIds);
        console.log(`O anterior ID é ${previousId}`);
  
        const documento = await getDocumento(previousId);
  
        setIdDoDocumento(previousId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        const intervencao_id = e.intervencao_id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlIntIntervencaoHighlight',
            value: [intervencao_id],
          },
          '*'
        )
      } else {
        console.log("Não há um anterior ID na lista.");
      }

    } catch(error){

      handleGenericError(error, "Não foi possivel abrir o documento!")

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
       
  }

  useEffect(() => {

    const elemento: any = document.querySelector(".k-window-content.k-dialog-content");

    if (elemento) {
      elemento.style.padding = "0px";
    }

  }, [openForm]);

  const handleMapCenter = (intervencao: Record<string, any>) => async () => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    //iframe.contentWindow?.postMessage({ type: "SiarlOcorrenciasSearch", value: [ocorrencia.id] }, '*')
    if (intervencao.id) {
      iframe.contentWindow?.postMessage(
        {
          type: 'SiarlIntIntervencaoCenter',
          value: [intervencao.id],
        },
        '*'
      )
    }
  }

  const handleInfoClickById = (intervencaoLocal: Record<string, any>) => async () => {
    postMessage({ type: "showLoader" }, "*");
    const id = intervencaoLocal.intervencao_id ?? intervencaoLocal.id;
    const intervencao = await getIntervencao(id);
    const tecnico = await GetUserNameTecnico(intervencao.utilizador_id);
    

     if (!intervencao) {
      postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
      postMessage({ type: "hideLoader" }, "*");
      return;
    }
    postMessage({ type: "hideLoader" }, "*");
    
    const iframe: any = document.getElementById('iframeGeoPortal')
    
    const objToShow = {
      ...intervencao,
      id: intervencao.id,
      localizacao: intervencao?.localizacao ?? undefined,
       nuts1: intervencao.nuts1 ?? undefined,
      nuts2: intervencao.nuts2 ?? undefined,
      nuts3: intervencao.nuts3 ?? undefined,
      distrito : intervencao.distrito ?? undefined,
      concelho: intervencao.mobilizacao ?? undefined,
      freguesia: intervencao.freguesia ?? undefined,
      arh: intervencao.arh ?? undefined,
      capitania : intervencao.capitania ?? undefined,
      massaagua: intervencao.massaagua ?? undefined,
      inicio: intervencao?.inicio? new Date(intervencao?.inicio):null,
      fim :intervencao?.inicio? new Date(intervencao?.fim):null,
      id_tipo_n1: intervencao?.tipo_n1 ?? undefined,
      id_tipo_n2: intervencao?.tipo_n2 ?? undefined,
      id_tipo_n3: intervencao?.tipo_n3 ?? undefined,
      estadoIntervencao: intervencao?.estado ?? undefined,
      id_prioridade: intervencao?.int_prioridade ?? undefined,
      id_int_pal_xxi_tip_nivel_1: intervencao?.int_pal_xxi_tip_nivel_1 ?? undefined,
      id_int_pal_xxi_tip_nivel_2: intervencao?.int_pal_xxi_tip_nivel_2 ?? undefined,
      id_int_pal_xxi_tip_nivel_3: intervencao?.int_pal_xxi_tip_nivel_3 ?? undefined,
      id_int_instrumento_planeamento: intervencao?.int_instrumento_planeamento ?? undefined,
      entidade: intervencao?.entidade ?? undefined,
      designacao: intervencao?.designacao ?? undefined,
      numero_intervencao: intervencao?.numero_intervencao ?? undefined,
      id_prioridade_instr_plan: intervencao?.id_prioridade_instr_plan ?? undefined,
      lstEntidades: preventPropsNullValues(intervencao.lstEntidades, "nome") ?? undefined,
      filedoc_cod: intervencao?.filedoc_cod ?? undefined,
      utilizador_nome : tecnico,
      praia: intervencao?.praia ?? undefined,
      inv_global: intervencao?.inv_global ? intervencao?.inv_global : undefined,
      fin_comunitario: intervencao?.fin_comunitario ? intervencao?.fin_comunitario.toFixed(2) : undefined,
      fin_nacional: intervencao?.fin_nacional ? intervencao?.fin_nacional.toFixed(2) : undefined,
      val_executado: intervencao?.val_executado ?? undefined,
      id_tipo_in : intervencao?.intComponente ?? undefined,
      objetivo : intervencao?.objetivo ?? undefined,
      data_registo: intervencao.data_registo ? moment.utc(new Date(intervencao.data_registo)).tz(CURRENT_TIMEZONE) : undefined,
      entidade_registo: entidadeUser ?? undefined,
      observacoes : intervencao.obs ?? undefined
    }
  

    sessionStorage.setItem('novaIntervencao', 'false')
    SessionStorageService.setItem('total_valor_execucao',intervencao?.val_executado)

    selectIntervencaoResult(objToShow)
    selectIntervencaoResultId(intervencao?.id)
    setIntervencaoSelected(objToShow);
    setShowResultadoIntervencao(false)
    setShowRegistarIntervencao(true)
    const idToSend = [intervencao?.id];

    iframe.contentWindow?.postMessage(
      { type: 'SiarlIntIntervencaoSearch', value: idToSend },
      '*'
    )
    iframe.contentWindow?.postMessage(
      { type: 'SiarlIntIntervencaoCenter', value: idToSend },
      '*'
    )
  }
  const intervencaoCustomCell = (props: GridCellProps) => (
    <ResultadoIntervencaoCommandGridCell
    {...props}
    onInfoClick={handleInfoClickById}
    onMapCenter={handleMapCenter}
    {...conditionalProps}
    />
  )

  const documentsCustomCell = (props: GridCellProps) => (
    <ResultadoDocumentoCommandGridCell
    onLocationMouseEnter={function (documentos: Record<string, unknown>): void {
      console.log("n/a");
    } } onLocationMouseLeave={function (documentos: Record<string, unknown>): void {
      console.log("n/a");
    } } onLocationClick={handleLocationClick} onDocumentPreviewClick={handleDocumentPreviewClickById} {...props}
    onInfoClick={handleInfoClickById}    />
  )


  const [dataState, setDataState] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const [dataStateDocumentos, setDataStateDocumentos] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const dataStateChange = (event: any) => {
    setDataResult(process(intervencoes ?? [], event.dataState));
    setDataState(event.dataState);
  };

  const [dataResult, setDataResult] = React.useState(
    process(intervencoes ?? [], dataState)
  );

  useEffect(() => {
    setDataResult(process(intervencoes ?? [], dataState));
}, [intervencoes, dataState]);

  const dataStateChangeDocumentos = (event: any) => {
    setDataResultDocumentos(process(documentosIntervencoes, event.dataState));
    setDataStateDocumentos(event.dataState);
  };

  const [dataResultDocumentos, setDataResultDocumentos] = React.useState(
    process(documentosIntervencoes, dataStateDocumentos)
  );

  const optionsImprimir = [
    {
      key: 'ExportarListaResultados',
      text: 'Resultados',
    },
  ]

  const optionsExportar = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'excel',
    },
    {
      key: 'ExportarListaResultadosPdf',
      text: 'PDF',
    },
    {
      key: 'ExportarListaResultadosShapeFile',
      text: 'Shapefile',
    },
    {
      key: 'ExportarTodasFichas',
      text: 'Fichas',
    },
  ]

  const canSeeIntervencao = hasPermission(PERMISSION_INTERVENCAO_PERFIL_BASICO) ||
  hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
  hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA) ||
  hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) ||
  hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA) ||
  hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL);

  
  const conditionalProps =  canSeeIntervencao
  ? { 
      onInfoClick: handleInfoClickById
  } 
  : {};
  
  useEffect(() => {

    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDefineExtraLayerTooltipColumns', value:{  layer: INT_INTERVENCAO_POINT_NAME,  columns: columns.columns.filter((x: { show: any; }) => x.show).map((option: { field: any; title: any; }) => ({
     field: option.field,
     title: option.title
   })) } },
      '*'
    )
  }, [columns]);

  
  useEffect(() => {
    SessionStorageService.setItem("columnsDocumentsIntervencao", columnsDocuments)
  }, [columnsDocuments])

  const itemRender = (props: { item: any; itemIndex: number }) => {
    const isTitleItem = props.item.key === 'titulo';
    if (isTitleItem) {
      // Item de título personalizado
      return (
        <div className={styles.DropDownButtonTitulo}>
          <span>{props.item.text}</span>
        </div>
      );
    } else {
      // Demais itens
      return (
        <div className={styles.DropDownButtonItem}>
          <span>{props.item.text}</span>
        </div>
      );
    }
  };
  const onItemClickExportar = async (event: any) => {
    if(event.item.key == "ExportarTodasFichas"){
      onItemClickExportarFichas();
    }
    if (event.item.key == 'ExportarListaResultadosExcel') {
      exportExcel();
    } else if (event.item.key == 'ExportarListaResultadosPdf') {
      exportPDF();
    }
    else if (event.item.key == "ExportarListaResultadosShapeFile") {
      const results = SessionStorageService.getItem('resultadoIntervencaoPesquisa')
  
      if (results) {
        const ids: number[] = []
        results.forEach((element: any) => {
          ids.push(element.id)
        })

        const file: any = await getShapeFile(ids);
        const filePath = 'shapeFileIntIntervencoes.zip';

        handleDownload(file, filePath);
    }
  } 
}
  
   const exportExcel = () => {
    _export.save();
  };

  const exportPDF = () => {
    _exportPdf.save();
  };

  const openPdfNewTab = () => {
    return new Promise<void>((resolve, reject) => {
        
        postMessage({ type: "showLoader" }, "*");

        setTimeout(() => {
           const columnsToShow = columns.columns.filter((x: any) => x.show);
            const dataToExport = intervencoes?.map((item: any) => {
                const filteredItem: any = {};
                columnsToShow.forEach((column: any) => {
                    filteredItem[column.field] = item[column.field];
                });
                return filteredItem;
            });
            
            exportPDFWithMethod(columnsToShow, dataToExport, 8)
                .then((pdfData: any) => {
                    postMessage({ type: "hideLoader" }, "*");

                        const base64Data = pdfData.split(";base64,")[1];
                        console.log(base64Data);
                        const blob = b64toBlob(base64Data, 'application/pdf');
                        const blobUrl = URL.createObjectURL(blob);

                      
                        window.open(blobUrl, '_blank');
                        resolve();
                  
                })
                .catch(error => {
                    console.error('Error exporting PDF:', error);
                    reject(error);
                });
        }, 1000);
    });
};

const onItemClickExportarFichas = async () => {
  try {

  
    const relatorios = [];

    const results = SessionStorageService.getItem('resultadoIntervencaoPesquisa');
  
 

    const idsIntervencao = results.map((o: any) => o.id);

    if(idsIntervencao.length  > RECORDS_LIMIT){
      postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fíchas" } }, '*')
      return false
      }
  

    const intervencoes = await getIntervencaoPorIds(idsIntervencao);
    
      postMessage({ type: 'showLoader' }, '*');
    
      for (const intervencaoId of idsIntervencao) {

      const intervencao = intervencoes.find((intervencao: any) => intervencao.id === intervencaoId);

      const objToSendImgMapa : any = {
        CodPrintTemplate: "RELATORIO_INT_INTERVENCAO",
        extendInfo: {
          spatialReference: {
            wkid: 0
          },
          xmin: 0,
          ymin: 0,
          xmax: 0,
          ymax: 0
        },
        ListOperationalLayerInfo: [
          {
            IdOperationLayer: OPERATIONAL_LAYER,
            UseLayerExtent: false,
            DefinitionExpression: "",
            ListServiceLayer: [
              {
                  LayerId: LAYER_INDEX_INT_INTERVENCOES,
                  DefinitionExpression: "id=" + intervencao?.id,
                  UseLayerExtent: true
              }
            ]
          }
        ]
      }

      const lstInstrumentosPlaneamento = SessionStorageService.getItem("dataInstrumentoPlaneamento");

      const formattedLstInstrumentosPlaneamento = lstInstrumentosPlaneamento?.map((item : any) => ({
        'InstrumentoPlaneamento': item.id_int_instrumento_planeamento?.designacao ?? '',
        'Tipo Nível 1': item.id_tipo_n1?.descricao ?? '-',
        'Tipo Nível 2': item.id_tipo_n2?.descricao ?? '-',
        'Tipo Nível 3': item.id_tipo_n3?.descricao ?? '-',
        'Código Intervenção': item.numero_intervencao ?? '-',
        'Prioridade': item.id_prioridade_instr_plan?.descricao ?? '-'
      }));
  
      
      const lstIndicadores = SessionStorageService.getItem("dataIndicadores");
  
      const formattedIndicadores = lstIndicadores?.map((item : any) => ({
        'Indicador': item.id_indicador?.descricao ?? '-',
        'Valor': item.valor ?? '-'
      }));
  
       
      const lstAcaoIntervencao = SessionStorageService.getItem("dataAcaoIntervencao");
  
      const formattedAcaoIntervencao = lstAcaoIntervencao?.map((item : any) => {
        console.log("item.id_tipo_n4");
        console.log(item.id_tipo_n4);
        return {
          'ID acao': item.id_acao ?? '-',
          'Designacao': item.designacao?.designacao ?? '-',
          'Estado': item.id_estado?.descricao ?? '-',
          'Tipo n4': item.id_tipo_n4 ? item.id_tipo_n4.descricao : '-',
          'Percentagem': item.percentagem ?? '-',
          'Valor execucao': item.valor_execucao ?? '-',
        };
      });
      
   
      const relatorio = {
        id: intervencao?.id,
        dados: {
          //  REGISTO
          'Nº Processo APA:': intervencao?.filedoc_cod ?? '',
          'Estado:': intervencao?.estado?.descricao ?? '',
          'Data/Hora Registo:': intervencao?.data_registo ? new Date(intervencao?.data_registo).toLocaleDateString() : '',
          'Técnico:' : intervencao?.utilizador_id ?? '',
          'Entidade:' : intervencao?.entidade_registo ?? '',

          //  IDENTIFIACAÇÃO
          'Designação:': intervencao?.designacao ?? '',
          'Código da Intervenção:' : intervencao?.numero_intervencao ?? '',
          'Prioridade:': intervencao?.int_prioridade?.descricao ?? '',
          'Investimento Global:': intervencao?.inv_global ?? '',
          'Financiamento Nacional:': intervencao?.fin_nacional ?? '',
          'Financiamento Comunitário:': intervencao?.fin_comunitario ?? '',
          'Data de início:': intervencao?.inicio ?? '',
          'Data de fim:': intervencao?.fim ?? '',
          'Valor Executado:': intervencao?.val_executado ?? '',
          'Fonte financiamento previsto:' : intervencao?.lstFinanciamento[0]?.designacao ?? '-',
          'Objetivo:': intervencao?.objetivo ?? '',

          //  LOCALIZAÇÃO
          'Concelhos:': intervencao?.concelhos[0]?.nome ?? '',
          'ARH:': intervencao?.arhs[0]?.nome ?? '',
          'Capitania:': intervencao?.capitanias[0]?.nome ?? '',
          'Praia:': intervencao?.praia?.nome ?? '',
          'Referência do local:': intervencao?.local ?? '',

          //  TIPOLOGIAS 
          'Tipologia Nível 1:': intervencao?.int_pal_xxi_tip_nivel_1?.descricao ?? '',
          'Tipologia Nível 2:': intervencao?.int_pal_xxi_tip_nivel_2?.descricao ?? '',
          'Tipologia Nível 3:': intervencao?.int_pal_xxi_tip_nivel_3?.descricao ?? '',

          //  OBSERVAÇÕES
          'Observações:': intervencao?.obs ?? '',

          //  INSTRUMENTOS DE PLANEAMENTO
          formattedLstInstrumentosPlaneamento,


          //  INDICADORES CONCRETIZAÇÃO
          formattedIndicadores,

          // ACAO INTERVENCAO
          formattedAcaoIntervencao,


          'Instrumento de planeamento:': intervencao?.int_instrumento_planeamento?.designacao ?? '',
          'Tipologia Nível 1': intervencao?.tipo_n1?.descricao ?? '',
          'Tipologia Nível 2': intervencao?.tipo_n2?.descricao ?? '',
          'Tipologia Nível 3': intervencao?.tipo_n3?.descricao ?? '',
        },  
        img_mapa: "",
        objJsonToCreateImg: objToSendImgMapa
      };
      
      relatorios.push(relatorio);
  }

    const mergedPdfBase64 = await relatorioIntervencaoMerge(relatorios);
    if (mergedPdfBase64) {
      const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    }
  } catch (error) {
    console.log(error);
    postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
  } finally {
    postMessage({ type: 'hideLoader' }, '*');
  }
};

  const onItemClickImprimir = async (event: any) => {
    openPdfNewTab();
  }

  const handleLocationClick = (item: Record<string, any>) => async () => {
    const id = item.intervencao_id ?? item.id;
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      { type: 'SiarlIntIntervencaoHighlight', value: [id] },
      '*'
    )
    
  } 

  const onItemClickImprimirDocumentos = (event: any) => {

    const link: HTMLAnchorElement | null = document.querySelector('#print-results-documentos');

    if (link) {
      link.click();
    }

    // if (event.item.key == 'ExportarListaResultados') {

      

    // }

  };

  const onItemClick = (event: any) => {

    if (event.item.key == 'ExportarFichasResultados') {

      const link: HTMLAnchorElement | null = document.querySelector('#print-results');

      if (link) {
        link.click();
      }

    } else if (event.item.key == 'ExportarListaResultados') {

      console.log(event.item.text);

    }

  };

  const options = [
    {
      key: 'ExportarFichasResultados',
      text: 'Fichas',
    },
    {
      key: 'ExportarListaResultados',
      text: 'Resultados',
    },
  ]
  const close = () => {
    setOpenForm(false);
  }  

  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

    };
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);  


  const onItemClickMais = (event: any) => {

    elementoClickMais(event);

      onItemClickExportar(event);

      onItemClickImprimir(event);
  };

  const optionsMais = [
    {
      key: 'titulo',
      text: 'Exportar',
    },
    ...optionsExportar.map(option => ({
      ...option,
      className: 'icon-siarl icon-exportar btnIconRegistar',
    })),
  ]

  const handleNewRegistoClick = () => {
    setIntervencaoSelected(undefined);
      selectIntervencaoResult(undefined);
      setShowResultadoIntervencao(false)
      sessionStorage.setItem('novaIntervencao', 'true')
      const loggedUser = JSON.parse(
        localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
      )
      setIntervencaoSelected({ utilizador_nome: loggedUser?.user?.name })

      if (setShowRegistarIntervencao) setShowRegistarIntervencao(true)
  }

const openAjuda = () => {
  window.open(URL_AJUDA_INTERVENCOES_INTERVENCAO, "_blank")
}


const PageTemplate = (props: any) => (
  <div className="page-template">
     <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px', padding: '10px' }}>
    
     <div>
     <img style={{ width: '128px', height: 'auto', marginLeft: '2px' }} src={base64SiarlImage} alt="SIARL Logo" />
     </div>
     <div style={{ textAlign: 'right' }}>
       <span style={{ fontSize: '18px', color: '#1ba49c' }}>PESQUISA DE INTERVENÇÕES</span>
     </div>
   </div>
   <div className="footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px' }}>
      
     <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
       <img style={{ width: '105px', marginBottom: '-25px' }} src={base64ApaImage} alt="APA Logo" />
       <img style={{ width: '280px', height: 'auto', marginBottom: '-25px' }} src={base64FooterImages} alt="Footer Image" />
     </div>
    
     <div style={{ flex: 1, textAlign: 'right', marginBottom: '-25px' }}>
      Data : {format(new Date(), "dd/MM/yyyy")} | Página {props.pageNum} de {props.totalPages}
     </div>
   </div>
 </div>
);

return (
  <div className={clsx(styles.base, isCurrentViewMaximized && commonStyles.maximizedBaseForm)}>
    {/* <div className={styles.header}>
      <div>
        <div className={styles.nomeDoModulo}>Intervenções</div>
        <div className={styles.tituloDaPagina}>Resultados de pesquisa
        </div>
      </div>

      <div>

        {hasPermission(PERMISSION_INSERIR_INTERVENCAO) && (  
              hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
              hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO)
              )? 
          <Button
            onClick={handleNewRegistoClick}
            className={styles.btnNovoRegisto}
            style={{ display: isMobile ? 'none' : '' }}
            id='novoRegisto'
            title='Nova intervenção'
          >
            <span className="icon-siarl icon-registar btnIconRegistar" /> &nbsp;{' '}
            Nova intervenção
          </Button>
        :  ''}

        <CSVLink
          title="Imprimir resultados"
          id="print-results-intervencao"
          separator={';'}
          data={intervencoes?.map((intervencao: any) => ({
            ...intervencao,
          }))}
          filename={`siarl-intervencao-${format(
            new Date(),
            'ddMMyyyHHmm'
          )}`}
          hidden
        ></CSVLink>

          {!isMobile &&
        <VisualizadorColunas 
              columns={selected===0?colums:columsDocuments} 
              setColumns={selected===0?setColums:setColumsDocuments}
              styles={styles.btnEditar2}  
           />
          }

        <button className={styles.btnEditar2} onClick={onItemClickImprimir} style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
          <span className="icon-siarl icon-imprimir"></span>
        </button>

        {!isMobile &&
          <DropDownButton
            items={optionsExportar}
            className={styles.btnImprimir}
            style={{marginTop: '-4px'}}
            iconClass="icon-siarl icon-exportar"
            onItemClick={onItemClickExportar}
            fillMode={'flat'}
            title='Exportar'
            itemRender={itemRender}
          ></DropDownButton>
        }

          {isMobile &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }

          {isMobile &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }

        <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
          <span className="icon-siarl icon-ajuda"></span>
        </button>
        <button className={styles.btnFechar} onClick={onCloseClick} title="Minimizar">
          <span className="icon-siarl icon-minimizar"></span>
        </button>

        {!isMobile &&
        <MaximizeButton className={styles.btnMaximizar} />
        }
      </div>
    </div> */}

    <TabStrip selected={selected} onSelect={handleSelect} scrollable={isMobile}>
      <TabStripTab title="Registos">
      <ExcelExport
        fileName='Resultado_Intervencoes'
            
            data={
               intervencoes?.map((intervencao: any) => ({
                    ...intervencao,
                    inicio: intervencao?.inicio ? format(new Date(intervencao.inicio), 'dd/MM/yyyy') : undefined,
                    fim: intervencao?.fim ? format(new Date(intervencao.fim), 'dd/MM/yyyy') : undefined,
              }))}


            ref={(exporter) => {
              setExcelExport(exporter)
            }}
          >
          <Grid
            className={styles.formResultadoTabs}
            sortable={true}
            onDataStateChange={dataStateChange}
            data={
              dataResult.data.length > 0
                ? {
                    ...dataResult,
                    data: dataResult.data.map((intervencao: any) => {
          
                      return {
                        ...intervencao,
                        inicio: intervencao?.inicio ? format(new Date(intervencao.inicio), 'dd/MM/yyyy') : undefined,
                        fim: intervencao?.fim ? format(new Date(intervencao.fim), 'dd/MM/yyyy') : undefined,
                      };
                    }),
                  }
                : intervencoes
                    ?.map((intervencao: any) => {
                      return {
                        ...intervencao,
                        inicio: intervencao?.inicio ? format(new Date(intervencao.inicio), 'dd/MM/yyyy') : undefined,
                        fim: intervencao?.fim ? format(new Date(intervencao.fim), 'dd/MM/yyyy') : undefined,
                      };
                    })
                    ?.slice(page.skip, page.take + page.skip)
            }
          total={dataResult.total != 0 ? dataResult.total : intervencoes.length}
          
            {...dataState}
            pageable={{
              buttonCount: 5,
              info: true,
              type: 'numeric',
              pageSizes: true,
              previousNext: true,
            }}
            //groupable={true}
          >
            <GridColumn cell={intervencaoCustomCell} width={60} />
            {columns?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined;  columnMenu: React.ComponentType<GridColumnMenuProps> | undefined;}, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} columnMenu={column.columnMenu} width={column.width} title={column.title} />
              )
            );
          })}
          </Grid>
          </ExcelExport>
        
        <GridPDFExport  
          fileName='Resultado_Intervencao'
         
          paperSize="A4"
          margin={{ top: '3cm', right: '1cm', bottom: '2cm', left: '1cm' }}
          landscape={true}
          pageTemplate={PageTemplate} 
          repeatHeaders={true}
          ref={(exporter) => {
            setPdfExport(exporter)
          }}
        >
          {
              <Grid
                sortable={true}
                 data={intervencoes}                
                pageable={{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: true,
                  previousNext: true,
                }}
                style={{ borderSpacing: '0' }} 
                //groupable={true}
              >
                {columns?.columns?.map((column: any, i: any) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} filter={column.filter} width={column.width} title={column.title} columnMenu={column.columnMenu}
                headerCell={() => <div className="pdf-header">{column.title}</div>}
                cell={(props: any) => (
                  <td style={{ fontSize: '10px', wordBreak: 'break-word', padding: '5px', border: '1px solid #1ba49c' , lineHeight: '1.3' }}>
                    {props.dataItem[column.field]}
                  </td>
                )}
                />
              )
            );
          })}
              </Grid>
            }
        </GridPDFExport>

        
      </TabStripTab>

      <TabStripTab title="Documentos">
        <ExcelExport
          fileName='Resultado_DocumentosIntervencoes'
          data={documentosIntervencoes}
          ref={(exporter) => {
            setExcelExport(exporter)
          }}
        >
          
          <Grid
            className={styles.formResultadoTabs}
            sortable={true}
            onDataStateChange={dataStateChangeDocumentos}
            data={dataResultDocumentos.data.length > 0 ? dataResultDocumentos : documentosIntervencoes?.slice(page.skip, page.take + page.skip)}
            {...dataState}
            pageable={{
              buttonCount: 5,
              info: true,
              type: 'numeric',
              pageSizes: true,
              previousNext: true,
            }}
            //groupable={true}
            total={documentosIntervencoes.length}

          >
            <GridColumn cell={documentsCustomCell} width={86} />
            {columnsDocuments?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
          </Grid>
        </ExcelExport>

        <GridPDFExport
          fileName='Resultado_Documentos_Intervencao'
          ref={(element) => {
            setPdfExport(element)
          }}
          margin="1cm"
        >
          <Grid
            className={styles.formResultadoTabs}
            sortable={true}
            onDataStateChange={dataStateChangeDocumentos}
            data={
              dataResultDocumentos.data.length > 0
                ? dataResultDocumentos
                : documentosIntervencoes
            }
            {...dataState}
            pageable={{
              buttonCount: 5,
              info: true,
              type: 'numeric',
              pageSizes: true,
              previousNext: true,
            }}
            //groupable={true}
          >
           {columnsDocuments?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
          </Grid>
        </GridPDFExport>
      </TabStripTab>
    </TabStrip>
    {openForm && (
        <Dialog
        className="ModalDocumentos"
          title={`Documento: ${idDoDocumento}`}
          onClose={close}
          style={{ zIndex: 999 }}
        >
          
            <ImagePreviewV2
              documentUrl={urlDoDocumento}
              next={(e: any) => nextPhoto(e)}
              previous={(e: any) => previousPhoto(e)}
            />

        </Dialog>
      )}
    <div
      className={clsx(styles.footer, styles.justify_one_child, isCurrentViewMaximized && commonStyles.maximizedFooter)}
    >
      <Button className={styles.btnPesquisar} onClick={clearSearchResults} title='Nova Pesquisa'>
        <span className="icon-siarl icon-pesquisar"></span>
        <span className={styles.rotulo}>
          {' '}&nbsp;{' '}
          Nova pesquisa
        </span>
      </Button>
    </div>
  </div>
)
}